import type { ZodInfer } from '@mntn-dev/utility-types'
import { EnumBuilder } from '@mntn-dev/utility-types'

export const [TransactionKinds, TransactionKindSchema, TransactionKindMap] =
  EnumBuilder('payment', 'charge')

export type TransactionKind = ZodInfer<typeof TransactionKindSchema>
